import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { CheckItem } from '../CheckItem';
import { CORE_PROMISE, withoutSystem, withSystem } from '../../data/salesContent';
export function ComparisonSection() {
  return <section className="bg-ink px-5 py-20 md:py-28" data-id="element-72" data-mp="4zl0mo5qyyc6">
      <div className="mx-auto max-w-5xl" data-id="element-73" data-mp="9zh50oicwrs9">
        <SectionHeading title="Preparar todo desde cero vs. trabajar con un sistema" data-id="element-74" data-mp="9y62es0ndq2q" />
        <div className="mt-14 grid gap-6 md:grid-cols-2" data-id="element-75" data-mp="3rfpd2kg8wel9">
          <div className="rounded-3xl border border-ink-line bg-ink-soft p-7 md:p-9" data-id="element-76" data-mp="3re4i4tq0qtmv">
            <h3 className="font-display text-xl font-black uppercase tracking-wide text-neutral-400 md:text-2xl" data-id="element-77" data-mp="3e5zrisx99j">Sin el sistema</h3>
            <ul className="mt-6 space-y-4" data-id="element-78" data-mp="3ne3z0vrz5u9h">
              {withoutSystem.map(i => <CheckItem key={i} variant="cross" className="text-lg text-neutral-400" data-id="element-79" data-mp="3nc9brat8dq28">
                  {i}
                </CheckItem>)}
            </ul>
          </div>
          <div className="rounded-3xl border-2 border-gold bg-ink-raised p-7 md:p-9" data-id="element-80" data-mp="3dfo9gx8lit23">
            <h3 className="font-display text-xl font-black uppercase tracking-wide text-gold md:text-2xl" data-id="element-81" data-mp="z6o4eil5k7ar">Con el sistema</h3>
            <ul className="mt-6 space-y-4" data-id="element-82" data-mp="u8ed4j2jtquf">
              {withSystem.map(i => <CheckItem key={i} className="text-lg font-medium text-cream" data-id="element-83" data-mp="187dztl6i3vny">
                  {i}
                </CheckItem>)}
            </ul>
          </div>
        </div>
        <p className="mt-14 text-center font-display text-2xl font-black uppercase leading-tight text-gold md:text-4xl" data-id="element-84" data-mp="ggzr03dch9j5">{CORE_PROMISE}</p>
      </div>
    </section>;
}